module.exports = __webpack_public_path__ + "static/img/Noah.1f98b2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Noah.png
// module id = kR2L
// module chunks = 1